// src/pages/AironHome.jsx
import React, { useState, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";

const AironHome = () => {
  const authState = useSelector((state) => state.authReducer || {});
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("HVAC LnD");

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };

  const groupNames = [
    { label: "HVAC LnD", emoji: "✍️" },                // Learning & skill capture
    { label: "HVAC Startup", emoji: "🚀" },           // Entrepreneurship / startup
    { label: "Owner Self Reflection", emoji: "🪞" },  // Self reflection stays
    { label: "HVAC Productivity", emoji: "⚡" },      // Efficiency / energy
    { label: "Operations", emoji: "🏭" },            // Industrial operations
    { label: "Root Cause Thinking", emoji: "🧠" },   // Mind + problem-solving
    { label: "Chronicle & Tasks", emoji: "🗂️" },     // Tasks, logs, notes
    { label: "HVAC CCM", emoji: "📅" },              // Calendar / maintenance
    { label: "HVAC Marketplace", emoji: "🛒" },      // e-commerce / marketplace
    { label: "Talent Solutions", emoji: "👷‍♂️" },     // Workforce / skill solutions
    { label: "Finance & Compliance", emoji: "💰" },   // Money + compliance
    { label: "HVAC Utilities", emoji: "⚙️" },        // Tools / utilities
    { label: "HVAC DeepTech", emoji: "🤖" },         // AI / smart HVAC tech
    { label: "HVAC ESG", emoji: "🌱" },              // Sustainability
    { label: "SigmaStudio", emoji: "🧮" },           // Six Sigma / analytics
    { label: "SprintCentral", emoji: "🏃‍♂️" },       // Agile sprints
    { label: "Processifyd", emoji: "🛠️" },          // Process / tools
    { label: "Earn Digital Income", emoji: "💳" },    // Payments / earnings
    { label: "HVAC Leaderboard", emoji: "🏆" },      // Performance ranking
    { label: "HVAC Games", emoji: "🎮" },           // Gamification
    { label: "Airon Adoption", emoji: "🌬️" },       // HVAC adoption / Airon module
];

  const menuButtons1 = [
    // ✍️ HVAC LnD
    { label: "HVAC Success Kit", emoji: "🧰", link: "/startupkit", group: "HVAC LnD" },
    { label: "Owner's Learning", emoji: "✍️", link: "/msme-bookworld", group: "HVAC LnD" },
    { label: "Technicians Learning", emoji: "✍️", link: "/msme-bookworld", group: "HVAC LnD" },
    { label: "HVAC Bookshelf", emoji: "📖", link: "/bookshelf", group: "HVAC LnD" },
    { label: "HVAC Shorts", emoji: "🗞️", link: "/litenshort", group: "HVAC LnD" },
    { label: "Trainings & Workshops", emoji: "🎓", link: "/enroll/workshop", group: "HVAC LnD" },
    { label: "Podcast", emoji: "🎙️", link: "/podcast-mylist", group: "HVAC LnD" },
    { label: "hvacTube", emoji: "▶️", link: "/msmetube", group: "HVAC LnD" },

    // 🚀 HVAC Startup
    { label: "About HVAC Sector", emoji: "📚", link: "/hvac-about", group: "HVAC Startup" },
    { label: "HVAC Glossary", emoji: "🔤", link: "/hvac-glossary", group: "HVAC Startup" },
    { label: "HVAC Roles", emoji: "🦺", link: "/hvac-roles", group: "HVAC Startup" },
    { label: "HVAC Services", emoji: "🛠️", link: "/hvac-masterlist", group: "HVAC Startup" },
    { label: "HVAC Eqipments", emoji: "🔧", link: "/hvac-masterlist", group: "HVAC Startup" },
    { label: "How To Open", emoji: "🗂️", link: "/hvac-howtoopen", group: "HVAC Startup" },
    { label: "Startup Checklist", emoji: "📋", link: "/hvac-startup-checklist", group: "HVAC Startup" },
    { label: "Startup Kit", emoji: "🧰", link: "/startupkit", group: "HVAC Startup" },
    { label: "Startup ERP", emoji: "📊", link: "/ledger", group: "HVAC Startup" },
    { label: "Startup Consultants", emoji: "🧑‍💼", link: "/think5whys-counsellors", group: "HVAC Startup" },
    { label: "Startup Boutique", emoji: "🏬", link: "/digiboutique", group: "Talent Solutions" },
    { label: "Funding", emoji: "💰", link: "/fundlanes", group: "HVAC Startup" },
    { label: "PMMY", emoji: "💪", link: "/growsure", group: "HVAC Startup" },    

    // 🪞 Owner Self Reflection
    { label: "Personal Digital Card", emoji: "💳", link: "/msme-digitalcard", group: "Owner Self Reflection" },
    { label: "Owner's Self Management", emoji: "🙋‍♀️", link: "/msme-self-chronicles", group: "Owner Self Reflection" },
    { label: "Personal Diary", emoji: "📔", link: "/mydiary-home", group: "Owner Self Reflection" },
    { label: "DeepThinking", emoji: "🧠", link: "/fivewhys-analysis-home", group: "Owner Self Reflection" },
    { label: "Focus Timer", emoji: "⏱️", link: "/msme-focustimerstart", group: "Owner Self Reflection" },
    { label: "IKIGAI", emoji: "🌸", link: "/myprofile-ikigai", group: "Owner Self Reflection" },
    { label: "My Outreach", emoji: "📣", link: "/outreach", group: "Owner Self Reflection" },
    { label: "My Limit", emoji: "📏", link: "/mylimit", group: "Owner Self Reflection" },
    { label: "Personal AI Counselling", emoji: "🧑‍💼🤖", link: "/aicounselling", group: "Owner Self Reflection" },
    { label: "Owner Productivity Suite", emoji: "🧠⚙️", link: "", group: "Owner Self Reflection" },  

    // ⚡ HVAC Productivity
    { label: "Enterprise Assessment", emoji: "🧠", link: "/msme-selfassessment", group: "HVAC Productivity" }, 
    { label: "Sustainability Score", emoji: "🧠", link: "/hvac-sustainability-assessment", group: "HVAC Productivity" }, 
    // { label: "Sustainability Score", emoji: "🌱", link: "/hvac-selfassessment", group: "HVAC Productivity" }, 
    { label: "HVAC Year Book", emoji: "📚", link: "/msmeyb-home", group: "HVAC Productivity" },
    { label: "Minutes of Meeting", emoji: "✍️", link: "/tasks/add", group: "HVAC Productivity" },
    { label: "Goal Board", emoji: "🏁", link: "/msme-goalboard", group: "HVAC Productivity" },
    { label: "Process & RACI Board", emoji: "🧩", link: "/msme-processraci", group: "HVAC Productivity" },
    { label: "Kanban", emoji: "📊", link: "/msme-kanban", group: "HVAC Productivity" },
    { label: "CommuniCapture", emoji: "📢", link: "/communicapture-home", group: "HVAC Productivity" },
    { label: "TrackBuddy AI", emoji: "📍", link: "/trackbuddy", group: "HVAC Productivity" },
    { label: "LLM Capture", emoji: "🧠🤖", link: "/msme-llmcapture", group: "HVAC Productivity" },
    { label: "Auto Payment Reminder", emoji: "⏰💳", link: "/prs", group: "HVAC Productivity" },
    { label: "KRA-KPI", emoji: "🎯", link: "", group: "HVAC Productivity" },
    { label: "SOPHub", emoji: "🔗", link: "/sophub", group: "HVAC Productivity" },
    { label: "POHub", emoji: "📦", link: "/pohub", group: "HVAC Productivity" },
    { label: "TRACK", emoji: "🚦", link: "/msme-track", group: "HVAC Productivity" },    
    { label: "Process Scorecard", emoji: "📈", link: "/msme-processscore", group: "HVAC Productivity" },
    { label: "HVAC Database", emoji: "💾", link: "/msmedb", group: "HVAC Productivity" },

    // 🏭 Operations
    { label: "Contract Manufacturing", emoji: "🤝", link: "/syntramfg-contractmanufacturing", group: "Operations" },
    { label: "Products", emoji: "📦", link: "/orderflow-products", group: "Operations" },
    { label: "Services", emoji: "🛠️", link: "/think-service-home", group: "Operations" },
    { label: "Rental", emoji: "🏠", link: "/think-rent-home", group: "Operations" },
    { label: "Enquiry", emoji: "📩", link: "/syntramfg-leads", group: "Operations" },
    { label: "Complaints", emoji: "⚠️", link: "/syntramfg-complaints", group: "Operations" },
    { label: "Equipment and Assets", emoji: "🏭", link: "/syntramfg-assets", group: "Operations" },

    // 🧠 Root Cause Thinking 
    { label: "Whys RCA", emoji: "🧠", link: "/fivewhys-analysis-home", group: "Root Cause Thinking" },
    { label: "Wisdom RCA", emoji: "🧠", link: "/msme-selfassessment", group: "Root Cause Thinking" },
    { label: "Fishbone", emoji: "🐟", link: "/msme-selfassessment", group: "Root Cause Thinking" },

    // 📖 Chronicle & Tasks
    { label: "Business Chronicles", emoji: "📖", link: "/msme-business-chronicles", group: "Chronicle & Tasks" },
    { label: "Business Diary", emoji: "📓", link: "/mydiary-home", group: "Chronicle & Tasks" },
    { label: "Business Journal", emoji: "🗒️", link: "/myjournal-home", group: "Chronicle & Tasks" },

    // 📅 HVAC CCM
    { label: "My Digital Card", emoji: "💼", link: "/msme-digitalcard", group: "HVAC CCM" },
    { label: "Client's Digital Card", emoji: "👤", link: "/contact-genious-clientcards", group: "HVAC CCM" },
    { label: "My Speaking Card", emoji: "🎙️", link: "/contact-genious-speakingcard", group: "HVAC CCM" },
    { label: "Card Visibility Dashboard", emoji: "📊", link: "/contact-genious-cardviewstats", group: "HVAC CCM" },
    { label: "Connect / PehchaanSetu", emoji: "🤝", link: "/pehchaansetu", group: "HVAC CCM" },
    { label: "Meeting Calendar", emoji: "📅", link: "/calendar-list", group: "HVAC CCM" },
    { label: "Visits for Meeting", emoji: "📍", link: "/visits-list", group: "HVAC CCM" },
    { label: "Meeting Thoughts", emoji: "💭", link: "/thoughts-list", group: "HVAC CCM" },
    { label: "Meeting TODO", emoji: "✅", link: "/todo-list", group: "HVAC CCM" },
    { label: "Meeting Tasks", emoji: "🛠️", link: "/tasks-list", group: "HVAC CCM" },
    { label: "Travelling for Meetings", emoji: "🚗", link: "/travels-list", group: "HVAC CCM" },
    { label: "Meeting Checklist", emoji: "📋", link: "/checklist-list", group: "HVAC CCM" },
    { label: "Meeting Record", emoji: "🗂️", link: "/meetings-list", group: "HVAC CCM" },
    { label: "Whisper", emoji: "🤫", link: "", group: "HVAC CCM" },
    { label: "Meeting Analytics AI", emoji: "🧠📈", link: "", group: "HVAC CCM" },

    // 👥 Talent Solutions
    { label: "BlueHands", emoji: "👐", link: "/bluehands-home", group: "Talent Solutions" },
    { label: "Consultants", emoji: "🧑‍💼", link: "/think5whys-counsellors", group: "Talent Solutions" },
    { label: "Digital Boutique", emoji: "🏬", link: "/digiboutique", group: "Talent Solutions" },

    // 💳 Finance & Compliance
    { label: "NPA Solutions", emoji: "⚠️", link: "/msme-npahome", group: "Finance & Compliance" },
    { label: "ValueShare", emoji: "💾", link: "/orderflow-earning-estimator", group: "Finance & Compliance" },
    { label: "Funding & Loans", emoji: "💰", link: "/fundlanes", group: "Finance & Compliance" },
    { label: "Loan", emoji: "💰", link: "/syntramfg-loan", group: "HVAC Utilities" },
    { label: "Insurance", emoji: "🛡️", link: "/syntramfg-insurance", group: "HVAC Utilities" },

    // ⚙️ HVAC Utilities 
    { label: "HVAC Events", emoji: "🎉", link: "/event-flow-home", group: "HVAC Utilities" },    
    { label: "ContractorNexus", emoji: "🕒", link: "/contractornexus", group: "HVAC Utilities" },
    { label: "Attendance", emoji: "🕒", link: "/chronocheck-home", group: "HVAC Utilities" },
    { label: "PehchaanSetu", emoji: "🔗", link: "/pehchaansetu", group: "HVAC Utilities" },
    { label: "Offboarded DB", emoji: "📤", link: "/offboarded-home", group: "HVAC Utilities" },
    { label: "Payment Dodger DB", emoji: "🚫💰", link: "/offboarded-home", group: "HVAC Utilities" },
    { label: "Business AI Counselling", emoji: "🧠", link: "/aicounselling", group: "HVAC Utilities" },
    { label: "Design Of Experiments", emoji: "🧪", link: "/doe", group: "HVAC Utilities" },
    { label: "About Bias-Variance", emoji: "⚖️", link: "/bv-about", group: "HVAC Utilities" },
    { label: "Bias-Variance in HVAC", emoji: "🏭", link: "/bv-sector", group: "HVAC Utilities" },    
    { label: "Bias-Variance Use Cases", emoji: "📚", link: "/bv-usecases", group: "HVAC Utilities" },
    { label: "Bias-Variance Readiness Scoring", emoji: "📊", link: "/bv-readiness", group: "HVAC Utilities" },
    { label: "Bias-Variance Recommendation Engine", emoji: "🧠", link: "", group: "HVAC Utilities" },

    // 🏪 HVAC Marketplace
    { label: "HVAC Marketplace", emoji: "🏪", link: "/orderflow-home", group: "HVAC Marketplace" },
    { label: "HVAC-as-a-Service", emoji: "🛠️", link: "/orderflow-home", group: "HVAC Marketplace" },
    { label: "Marketing Campaigns", emoji: "📣", link: "/treach", group: "HVAC Marketplace" },
    { label: "CSAT", emoji: "💬", link: "/csat", group: "HVAC Marketplace" },
    { label: "BoloGrahak", emoji: "🙋‍♀️", link: "/bolograhak", group: "HVAC Marketplace" },
    { label: "Forum", emoji: "🗣️", link: "/povify-home", group: "HVAC Marketplace" },
    { label: "Innovations", emoji: "🚀", link: "/msme-innovationhub", group: "HVAC Marketplace" },

    // 🤖 HVAC DeepTech
    { label: "Work with AI", emoji: "🤖", link: "/msme-vsai", group: "HVAC DeepTech" },
    { label: "AI for HVAC", emoji: "🧑‍💼🤖", link: "/agenticsim", group: "HVAC DeepTech" },
    { label: "TwiWorld", emoji: "🌐", link: "/twiworld", group: "HVAC DeepTech" },
    { label: "HVAC MetaVerse", emoji: "🕶️", link: "/msme-metaverse", group: "HVAC DeepTech" },
    { label: "HVAC IIOT", emoji: "🌬️", link: "", group: "HVAC DeepTech" },
    { label: "HVAC BaaS", emoji: "⚙️", link: "", group: "HVAC DeepTech" },
   
    // 🌱 HVAC ESG
    { label: "Ecology Impact", emoji: "🌱", link: "/coolearth-home", group: "HVAC ESG" },

    // 🧮 SigmaStudio
    { label: "My Variations", emoji: "📋", link: "/sigmastudio-variations", group: "SigmaStudio" },
    { label: "Calculators", emoji: "🧮", link: "/sigmastudio-calculators", group: "SigmaStudio" },
    { label: "SIPOC", emoji: "🗺️", link: "/sigmastudio-sipoc", group: "SigmaStudio" },
    { label: "Process Flow", emoji: "🔀", link: "/sigmastudio-processchart", group: "SigmaStudio" },
    { label: "Pareto Analysis", emoji: "📊", link: "/sigmastudio-pareto", group: "SigmaStudio" },
    { label: "5 Whys", emoji: "❓", link: "/sigmastudio-fivewhys", group: "SigmaStudio" },
    { label: "5S", emoji: "🧹", link: "/sigmastudio-fives", group: "SigmaStudio" },
    { label: "Poka-Yoke", emoji: "🛡️", link: "/sigmastudio-pokayoke", group: "SigmaStudio" },
    { label: "Kanban", emoji: "🪜", link: "/sigmastudio-kanban", group: "SigmaStudio" },
    { label: "Kaizen", emoji: "🔁", link: "/sigmastudio-kaizen", group: "SigmaStudio" },
    { label: "Control Charts", emoji: "📈", link: "/sigmastudio-controlcharts", group: "SigmaStudio" },
    { label: "Fishbone (Ishikawa)", emoji: "🐟", link: "/sigmastudio-fishbone", group: "SigmaStudio" },
    { label: "DOE", emoji: "🧪", link: "/sigmastudio-doe", group: "SigmaStudio" },
    { label: "Gage R&R", emoji: "📏", link: "/sigmastudio-rnr", group: "SigmaStudio" },
    { label: "Matrix Charts", emoji: "🗂️", link: "/sigmastudio-matrix", group: "SigmaStudio" },
    { label: "RACI Matrix", emoji: "👥", link: "/sigmastudio-raci", group: "SigmaStudio" },
    { label: "KRAs", emoji: "🎯", link: "/sigmastudio-kra", group: "SigmaStudio" },
    { label: "KPIs", emoji: "🏁", link: "/sigmastudio-kpi", group: "SigmaStudio" },

    // 🏃 SprintCentral
    { label: "Three Points Formula", emoji: "📊", link: "/sprintcentral-threepf", group: "SprintCentral" },
    { label: "Projects", emoji: "📁", link: "/sprintcentral-projects", group: "SprintCentral" },
    { label: "Agile Board", emoji: "📋", link: "/sprintcentral-agile-board", group: "SprintCentral" },
    { label: "Agile Team", emoji: "👥", link: "/sprintcentral-team-list", group: "SprintCentral" },
    { label: "Epic", emoji: "🗂️", link: "/sprintcentral-epic-list", group: "SprintCentral" },
    { label: "Story", emoji: "📄", link: "/sprintcentral-story-list", group: "SprintCentral" },
    { label: "Backlog", emoji: "📝", link: "/sprintcentral-create-backlog", group: "SprintCentral" },
    { label: "Sprint", emoji: "🏃‍♂️", link: "/sprintcentral-create-sprint", group: "SprintCentral" },
    { label: "Task", emoji: "✅", link: "/sprintcentral-create-task", group: "SprintCentral" },
    { label: "Issue", emoji: "❗", link: "/sprintcentral-create-issue", group: "SprintCentral" },
    { label: "Cost", emoji: "💲", link: "/sprintcentral-enter-cost", group: "SprintCentral" },
    { label: "Agile Meetings", emoji: "📆", link: "/sprintcentral-create-meeting", group: "SprintCentral" },
    { label: "Documents", emoji: "📄", link: "/sprintcentral-document-create", group: "SprintCentral" },
    { label: "Communications", emoji: "💬", link: "/sprintcentral-message-create", group: "SprintCentral" },
    
    // ✔️ Processifyd
    { label: "Processifyd Masters", emoji: "✔️", link: "/processifyd-masters", group: "Processifyd" },
    { label: "Clients", emoji: "👥", link: "/processifyd-clients", group: "Processifyd" },
    { label: "Data Mining", emoji: "➕", link: "/processifyd-data-mining", group: "Processifyd" },
    { label: "One-View", emoji: "✏️", link: "/processifyd-one-view", group: "Processifyd" },
    { label: "Training & Skilling", emoji: "🎓", link: "/processifyd-training-skilling", group: "Processifyd" },
    { label: "Training", emoji: "🔄", link: "/processifyd-training", group: "Processifyd" },
    { label: "Approvals", emoji: "✊", link: "/processifyd-approvals", group: "Processifyd" },
    { label: "Communications", emoji: "💬", link: "/processifyd-communications", group: "Processifyd" },
    { label: "Logs", emoji: "🗂️", link: "/processifyd-logs", group: "Processifyd" },
    { label: "IIOT & Telemetry", emoji: "🌬️", link: "/processifyd-iiot-telemetry", group: "Processifyd" },

    // 💰 Earn Digital Income
    { label: "Monthly Digital Income", emoji: "💻💰", link: "/msme-bookworld", group: "Earn Digital Income" },
    { label: "Kharcho Jeeto", emoji: "💰", link: "/kharchojeeto", group: "Earn Digital Income" },
    { label: "Referral Income", emoji: "🔗", link: "/orderflow-earning-estimator", group: "Earn Digital Income" },
    { label: "Resell", emoji: "♻️", link: "/msme-enroll", group: "Earn Digital Income" },
    { label: "Rewarding Ads", emoji: "🎁📢", link: "/visigift-home", group: "Earn Digital Income" },
    { label: "Rewarding Videos", emoji: "🎥", link: "/orderflow-spotbuy", group: "Earn Digital Income" },
    { label: "Digital Boutique", emoji: "🛍️", link: "/digiboutique", group: "Earn Digital Income" },

    // 🏆 HVAC Leaderboard
    { label: "HVAC Ranking", emoji: "🏆", link: "/udyampragatiscore", group: "HVAC Leaderboard" },

    // 🎮 HVAC Games
    { label: "Mind of a CEO Series", emoji: "🧠", link: "/msme-games-strategic", group: "HVAC Games" },
    { label: "Operational Intelligence", emoji: "⚙️", link: "/msme-games-operational", group: "HVAC Games" },
    { label: "Relaxation + Clarity", emoji: "🎯", link: "/msme-games-edutainment", group: "HVAC Games" },
    { label: "Other HVAC Games", emoji: "🕹️", link: "/hvac-games-other", group: "HVAC Games" },
    { label: "Other Games", emoji: "🕹️", link: "/msme-games-other", group: "HVAC Games" },

    // 🌬️ Airon Adoption
    { label: "Ladder", emoji: "🪜", link: "/msme-think5whysmaturity", group: "Airon Adoption" },
    { label: "Stakeholders", emoji: "👨‍💼", link: "/msme-think5whysroles", group: "Airon Adoption" },
    { label: "SAKSHAM HVAC Advisor", emoji: "🤝", link: "/msme-advisors", group: "Airon Adoption" },
    { label: "Empowering PMMY Enterprises", emoji: "💪", link: "/growsure", group: "Airon Adoption" },    
];

  const filteredButtons = menuButtons1.filter((btn) => btn.group === activeTab);

  return (
    <div className="min-h-screen flex flex-col bg-black text-gray-100 font-sans">
      <header className="sticky top-0 z-50 bg-black border-b border-green-400 px-4 py-3 flex items-center justify-between">
        <div className="flex flex-col">
          <div className="text-lg lg:text-xl font-bold text-yellow-200">
              <i className="fa-solid fa-wind text-cyan-400"></i>
              Airon
            </div>
          <div className="text-[11px] text-gray-200">HVAC Intelligence for People, Planet & Performance</div>
          <div className="text-[10px] lg:text-sm text-yellow-200">Sector Centric. Transparency. Connecting Skill with Productivity</div>
        </div>

        <div className="hidden md:flex items-center gap-3">
          {isLoggedIn ? (
            <>
              <div className="text-xs lg:text-sm text-green-300">{userName}</div>
              <button
                onClick={handleLogout}
                className="w-8 mt-2 px-2 py-1 rounded-md bg-red-600 hover:bg-red-700 transition"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate("/login")}
                className="w-8 px-2 py-1 rounded-full border border-gray-700 text-sm text-gray-200 hover:bg-gray-800"
              >
                🔐 
              </button>
            </>
          )}
        </div>
        <button
          onClick={() => setIsMobileMenuOpen((s) => !s)}
          className="md:hidden w-8 h-8 flex items-center justify-center text-2xl text-green-300"
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? "×" : "☰"}
        </button>
      </header>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-gray-900 border-b border-gray-800 px-4 py-3">
          {isLoggedIn ? (
            <div className="flex flex-col items-center gap-3">
              <div className="text-green-300 text-xs lg:text-sm font-medium">{userName}</div>
                <div className="flex gap-3">
                  <button
                    onClick={handleLogout}
                    className="w-8 p-2 rounded-md bg-red-600 hover:bg-red-700"
                  >
                    ⏻
                  </button>
                </div>
            </div>
          ) : (
            <div className="flex justify-center gap-6">
              <Link to="/login" className="text-green-300 w-8">🔐</Link>
            </div>
          )}
        </div>
      )}

      <div className="bg-green-800 text-white text-xs lg:text-sm py-2">
        <div className="px-1 flex flex-wrap justify-center gap-2">
          <a href="/airon-about" className="hover:text-yellow-200">💭 About</a>
          <Link to="/litenshort" className="hover:text-yellow-200">🗞️ News</Link>
          <a href="/fundlanes" className="hover:text-yellow-200">💰 Funding</a>
          <a href="/ledger" className="hover:text-yellow-200">📊 ERP</a>
          <a href="/msme-think5whysfaq" className="hover:text-yellow-200">🤔 FAQ</a>
          <a href="/agenticsim" className="hover:text-yellow-200">🤖 Ask AI</a>
        </div>
      </div>

      <div className="mt-1 mb-1 px-1 py-2 border-b border-gray-500">
        <div className="grid grid-cols-3 lg:grid-cols-7 gap-1 border-gray-600 place-items-center">
          {groupNames.map((group) => (
            <button
              key={group.label}
              onClick={() => setActiveTab(group.label)}
              className={`flex flex-col items-center justify-center w-full px-1 py-1 rounded-md text-xs lg:text-sm font-medium transition ${
                activeTab === group.label
                  ? "bg-green-700 text-yellow-200"
                  : "bg-gray-800 text-gray-200 hover:bg-gray-700"
              }`}
              aria-pressed={activeTab === group.label}
            >
              <span className="text-sm lg:text-lg">{group.emoji}</span>
              <span className="text-[10px] lg:text-xs mt-1 text-center">{group.label}</span>
            </button>
          ))}
        </div>
      </div>

      <main className="flex-grow mx-auto px-3 py-2 w-full justify-center items-center text-center">
        <div className="grid grid-cols-3 lg:grid-cols-7 gap-1 place-items-center">
          {filteredButtons.length === 0 ? (
            <div className="col-span-3 lg:col-span-7 text-center text-gray-400">
              No items in this category.
            </div>
          ) : (
            filteredButtons.map((btn, idx) => (
              <button
                key={`${btn.label}-${idx}`}
                onClick={() => navigate(btn.link)}
                className="flex flex-col items-center justify-center w-full px-1 py-1 rounded-md text-[10px] text-xs lg:text-sm font-medium transition bg-transparent hover:bg-green-700 hover:text-yellow-200 text-gray-100 break-words text-center shadow-sm"
                title={btn.label}
              >
                <span className="text-sm lg:text-lg">{btn.emoji}</span>
                <span className="text-[10px] lg:text-xs mt-1">{btn.label}</span>
              </button>
            ))
          )}
        </div>
      </main>
      <footer className="bg-black border-t border-green-400 text-white py-4">
        <div className="px-3 flex flex-col lg:flex-row items-center justify-between gap-3">
          <div className="text-sm text-yellow-200">© 2025 Think5Whys Global DeepTech Solutions.</div>
          <div className="flex flex-wrap gap-4 text-sm">
            <Link to="/about-us" className="hover:text-green-300">About</Link>
            <Link to="/privacy-policy" className="hover:text-green-300">Privacy Policy</Link>
            <Link to="/terms-of-use" className="hover:text-green-300">Terms of Use</Link>
            <Link to="/contact-us" className="hover:text-green-300">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default AironHome;
